import userService from '@/services/userService'
import api from '@/services/api'
import _ from 'lodash'
import router from '@/router'

const token = localStorage['token'] || ''
const username = localStorage['username'] || ''

if (token) {
  api.defaults.headers.common['Authorization'] = `Token ${token}`
}

let cachedUser
if (username) {
  cachedUser = {username: username}
}

const state = {
  users: [],
  token: token,
  profile: {},
  user: cachedUser || {},
  registerError: null,
}

const getters = {
  user: state => state.user,
  users: state => state.users,
  token: state => state.token,
  isAuth: state => {
    return state.token.length > 0 && !_.isEmpty(state.user)
  }
}

const actions = {
  getUsers ({ commit }) {
    userService.fetchUsers()
    .then(users => users.results)
    .then(users => {
      commit('setUsers', users)
    })
  },
  getProfile ({ commit }, data) {
    userService.fetchUserDetail(data.username)
      .then(data => {
        commit('setProfile', data)
        commit('lists/setLists', data.lists, {root: true})
      })
  },
  getUserDetails({ commit, state }) {
    userService.fetchUserDetail(state.user.username)
      .then(data => {
        commit('setUser', data)
      })
  },
  clearProfile ({ commit }) {
    commit('setProfile', {})
    commit('lists/setLists', [], {root: true})
  },
  loginUser ({ dispatch }, user) {
    userService.loginUser(user)
      .then(data => {
        dispatch('setUserState', data)
        router.push('/')
      })
  },
  logOutUser ({ commit }) {
    delete localStorage['token']
    delete localStorage['username']
    delete api.defaults.headers.common['Authorization']
    commit('setToken', '')
    commit('setUser', {})
  },
  setUser ({ commit }, data) {
    commit('setUser', data.user)
  },
  setUserState ({ commit }, data) {
    commit('setToken', data.token)
    commit('setUser', data.user)
    api.defaults.headers.common['Authorization'] = `Token ${data.token}`
    localStorage['token'] = data.token
    localStorage['username'] = data.user.username
  },
  registerUser ({ commit, dispatch }, user) {
    commit('setRegisterError', null)
    userService.registerUser(user)
      .then(data => {
        dispatch('setUserState', data)
        router.push({ name: 'profile', params: { username: data.user.username } })
      })
      .catch(err => {
        commit('setRegisterError', err.response.data.error)
      })
  }
 }

const mutations = {
  setUsers (state, users) {
    state.users = users
  },
  setProfile (state, profile) {
    state.profile = profile
  },
  setToken (state, token) {
    state.token = token
  },
  setUser (state, user) {
    state.user = user
  },
  setRegisterError (state, error) {
    state.registerError = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}